var ControlGroup = require('control/control-group');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var name = Codec.readString(input);
        return new ControlGroup(name);
    },
    write : function(output, group) {
        Codec.writeString(output, group.name);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/control/control-group-serialiser.js
// module id = 297
// module chunks = 0